<template>
  <component
    :is="$register ? 'q-scroll-area': 'div'"
    :class="$register ? 'full-height' :'page q-pb-xl'"
    data-cy="activity-page"
  >
    <q-parallax
      v-if="!$q.screen.lt.md && !isHidePosterStyle && !$register"
      :style="{ 'height': [$q.screen.lt.lg || $register ? '330px' : '440px'] }"
      scroll-target="body"
      class="q-parallax_wrap"
      :speed="1"
    >
      <template #media>
        <img
          style="z-index:-1;"
          :style="{ 'top': $q.screen.lt.lg ? '-10%' : '-20%' }"
          :src="findActivityBySlug.bannerImageUrl || findActivityBySlug.posterImageUrl"
        >
      </template>
      <q-btn
        v-if="findActivityBySlug.videoId && !$register"
        push
        rounded
        padding="md lg"
        size="lg"
        color="primary"
        icon="play_arrow"
        @click="trailer = true; $trackEvent($customerEvents.ACTIVITY_PAGE_CLICKED_POSTER, { activityId: findActivityBySlug.id, activityName: findActivityBySlug.name })"
      />
      <div class="container absolute-bottom">
        <div
          class="row items-stretch justify-center overflow-hidden"
          style="position: relative; flex-shrink: 1;"
        >
          <div class="col-3" />
          <div
            class="info-section col-9 q-pa-lg justify-center text-white"
          >
            <h1
              class="text-h3 text-bold q-my-sm"
            >
              {{ findActivityBySlug.name }}
            </h1>
          </div>
        </div>
      </div>
    </q-parallax>
    <div
      :class="isHidePosterStyle ? ($q.screen.lt.md? '' : (currentSite.moviePageConfig.backgroundColor !== 'custom' ? 'bg-' + currentSite.moviePageConfig.backgroundColor : '') + ' ' + (currentSite.moviePageConfig.useLightText ? 'text-white' : 'text-dark') ) : 'container'"
      :style="{ 'background-color': $q.screen.lt.md || !isHidePosterStyle ? '' : (currentSite.moviePageConfig.backgroundColor === 'custom' ? currentSite.moviePageConfig.backgroundColorHex : '') }"
    >
      <div
        class="row items-stretch"
        :class="isHidePosterStyle && !$register ? ($q.screen.lt.md ? 'q-py-md container' : 'q-py-xl container' ) : ''"
      >
        <div
          v-if="isHidePosterStyle"
          class="poster-section  justify-center items-start"
          :class="[
            $q.screen.lt.md ? 'q-pt-sm q-pb-sm q-px-md' : 'q-pr-md',
            $register ? 'col-6 col-md-3 col-lg-3 q-px-lg' : 'col-12 col-md-6 col-lg-5'
          ]"
        >
          <q-img
            style="width: 100%; z-index: 2;"
            class="rounded-borders cursor-pointer"
            :class="[$q.screen.lt.md ? '' : 'q-mt-xl q-mb-md shadow-5']"
            :src="$register ? findActivityBySlug.posterImageUrl : findActivityBySlug.bannerImageUrl"
            :ratio="$register ? 2/3 : 4/3"
            @click="trailer = true; $trackEvent($customerEvents.ACTIVITY_PAGE_CLICKED_POSTER, { activityId: findActivityBySlug.id, activityName: findActivityBySlug.name })"
          >
            <q-btn
              v-if="findActivityBySlug.videoId && !$q.screen.lt.md && !$register "
              rounded
              padding="'md'"
              size="sm"
              color="primary"
              style="border-radius: 50px; font-weight: bolder;width: 130px; min-height: 55px;"
              class="row absolute-center q-pl-lg"
              @click.stop="trailer = true; $trackEvent($customerEvents.ACTIVITY_PAGE_CLICKED_POSTER, { activityId: findActivityBySlug.id, activityName: findActivityBySlug.name })"
            >
              <q-avatar
                class="q-ma-xs absolute-left"
                icon="play_arrow"
                color="white"
                text-color="primary"
              />
              watch <br> trailer
            </q-btn>
          </q-img>
        </div>
        <div
          v-else
          class="poster-section col-12 col-md-3 justify-center items-center"
          :style="{ 'margin-top': [$q.screen.lt.md ? '' : '-150'] + 'px' }"
          :class="[
            $q.screen.lt.md ? 'q-pt-lg q-pb-md q-px-md' : 'q-pr-md'
          ]"
        >
          <q-img
            style="width: 100%; z-index: 2; position: relative;"
            class="rounded-borders cursor-pointer"
            :class="[$q.screen.lt.md ? '' : 'shadow-5']"
            :src="$q.screen.lt.md ? findActivityBySlug.bannerImageUrl : findActivityBySlug.posterImageUrl"
            :ratio="$q.screen.lt.md ? 16/9 : 2/3"
            @click="trailer = true; $trackEvent($customerEvents.ACTIVITY_PAGE_CLICKED_POSTER, { activityId: findActivityBySlug.id, activityName: findActivityBySlug.name })"
          />
        </div>
        <template v-if="!$q.screen.lt.md">
          <div
            class="info-section q-py-lg q-px-lg"
            :class="isHidePosterStyle ? ($register ? 'col-6 col-md-9 col-lg-9' : 'col-12 col-md-6 col-lg-7') : 'col-9'"
          >
            <template v-if="isHidePosterStyle">
              <h1
                class="text-h3 text-bold q-mb-md q-mt-lg"
                :class="currentSite.moviePageConfig.useLightText ? 'text-white' : 'text-primary'"
              >
                {{ findActivityBySlug.name }}
              </h1>
            </template>
            <h5
              class="text-h5 q-mt-none q-mb-xs"
              :class="isHidePosterStyle ? (currentSite.moviePageConfig.useLightText ? 'text-white' : 'text-dark') : 'text-dark'"
            >
              Overview
            </h5>
            <!-- eslint-disable vue/no-v-html -->
            <!-- v-html produced by tool -->
            <div
              :class="isHidePosterStyle ? (currentSite.moviePageConfig.useLightText ? 'text-white' : 'text-dark') : 'text-dark'"
              v-html="findActivityBySlug.descriptionWithBreaks"
            />
          </div>
        </template>
      </div>
      <div
        v-if="$q.screen.lt.md"
        class="row items-stretch q-px-md justify-center container"
      >
        <h1
          class="text-h4 text-bold q-my-sm text-primary text-center full-width"
        >
          {{ findActivityBySlug.name }}
        </h1>
        <div
          class="text-dark full-width"
          v-html="findActivityBySlug.descriptionWithBreaks"
        />
      </div>
    </div>

    <div
      v-if="!$register"
      class="row justify-center q-ma-xl"
    >
      <q-btn
        color="primary"
        size="lg"
        @click="$router.push(`/checkout/activity/${findActivityBySlug.urlSlug}`)"
      >
        Book Now
      </q-btn>
    </div>

    <q-dialog
      v-model="trailer"
      persistent
      :maximized="maximizedToggle"
      transition-show="slide-up"
      transition-hide="slide-down"
    >
      <q-card
        class="bg-dark text-white"
        :class="[$q.screen.lt.lg ? '' : 'q-mx-xxl q-my-xs']"
        :style="$q.screen.lt.md ? '' : 'height: auto;'"
      >
        <q-bar>
          <q-space />

          <q-btn
            v-close-popup
            icon="close"
            flat
            round
            dense
          />
        </q-bar>
        <q-resize-observer
          debounce="500"
          @resize="setVideoStyle"
        />

        <q-video
          :style="{ 'top': $q.screen.lt.md ? '20%' : '' }"
          :ratio="16/9"
          :src="findActivityBySlug.videoSource + embeddedParams"
        />
      </q-card>
    </q-dialog>
  </component>
</template>

<script>
import { date } from 'quasar'

const { formatDate } = date

const VIEWPORT_RATIO_16_BY_9_AS_PERCENTAGE = (9 / 16) * 100

export default {
  name: 'ActivityPage',
  configuration: ['currentSite'],
  context: ['currentUser'],
  meta () {
    return {
      title: this.findActivityBySlug.name || this.currentSite.displayName,
      meta: {
        description: { name: 'description', content: `${this.findActivityBySlug.description}` || this.currentSite.siteDescription }
      }
    }
  },
  props: {
    activityId: {
      type: Number,
      required: false,
      default: null
    }
  },
  data () {
    return {
      trailer: false,
      embeddedParams: '',
      maximizedToggle: true,
      videoStyle: '',
      readMore: true
    }
  },
  models: {
    findActivityBySlug: {
      ticketTypes: true,
      maxActivitySpaceCapacity: true,
      variables () {
        return {
          urlSlug: this.computedActivitySlug,
          skip: !this.computedActivitySlug
        }
      },
      immediate: true
    }
  },
  computed: {
    computedActivitySlug () {
      return this.activityId ? this.activityId.toString() : this.$route.params.slug
    },
    loggedIn () {
      return this.currentUser && this.currentUser.isRemote
    },
    isHidePosterStyle () {
      return this.$register || this.currentSite.moviePageConfig.hidePosters
    }
  },
  created () {
    this.trailer = this.$route.query.autoshow === 'true' || this.$route.query.autoplay === 'true' || this.trailer
    this.embeddedParams = this.$route.query.autoplay === 'true'
      ? '?autoplay=1&mute=1'
      : this.embeddedParams

    _.extend(this, {
      formatDate
    })
  },
  methods: {
    setActivityId (activityId) {
      this.activityId = activityId
    },
    setVideoStyle () {
      const ratio = ((window.innerHeight / window.innerWidth) * 100).toFixed(2)
      this.videoStyle = ratio < VIEWPORT_RATIO_16_BY_9_AS_PERCENTAGE ? `padding-bottom: ${ratio}%` : ''
    }
  },
  async trackPage () {
    if (this.computedActivitySlug) {
      await this.findActivityBySlug.ensureLoaded()
    }
    return {
      activityId: this.findActivityBySlug?.id,
      activityName: this.findActivityBySlug?.name
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  width: 100%;
  margin: -10px auto 0;
}
.q-parallax_wrap:before{
  content: '';
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 0;
  background: linear-gradient(0deg,#000 0%,rgba(0,0,0,0.6) 20%,rgba(0,0,0,0.15) 50%,transparent 100%);
}
.border-grey-3{
  border: 3px solid $grey-4;
}

</style>
